import {usersConstants} from '../constants';

export const usersActions = {
    login,
    permissions,
};

function login (user) {

    return dispatch => {
        dispatch(success(user));
    };

    function success (user) {
        return {type: usersConstants.LOGIN_SUCCESS, user}
    }
}

function permissions (permissions) {

    return dispatch => {
        dispatch(success(permissions));
    };

    function success (permissions) {
        return {type: usersConstants.SET_PERMISSIONS, permissions}
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/users.actions.js